import { ReactElement } from 'react'
import GridLayout, { Layout } from 'react-grid-layout'
import { useResizeDetector } from 'react-resize-detector'

export interface IDraggableChartsProps {
  children: ReactElement[]
  rowHeight?: number
  margin?: [number, number]
  className?: string
  layoutOptions?: Omit<Layout, 'i' | 'x' | 'y' | 'h'>
}

const grabKeys = (layout: Layout) => String(layout.i)

/**
  Generic component that takes an array of React elements as children and returns them as a draggable list.

  :: Notes ::
  - layoutOptions can be merged with the Layout item
  - rowHeight is defaulted for DataInputGraph

  :: Uses ::
  Currently used to rearrange the order of DataInputGraphs.
*/
export const DraggableColumn = ({
  children,
  rowHeight = 252,
  margin = [0, 0],
  className,
  layoutOptions
}: IDraggableChartsProps) => {
  const layout: Layout[] = children.map((element, index) => ({
    i: element.key as string,
    y: index,
    x: 0,
    h: 1,
    w: 12,
    ...layoutOptions
  }))

  const { ref: targetRef, width } = useResizeDetector()

  // ! GridLayout key is a hack to force React to rerender the component

  return (
    <div ref={targetRef}>
      {Boolean(width) && (
        <GridLayout
          key={layout.map(grabKeys).join()}
          isDraggable
          cols={12}
          rowHeight={rowHeight}
          width={width}
          margin={margin}
          layout={layout}
          className={`layout relative ${className || ''}`}
          draggableHandle='.drag-handle'
        >
          {children}
        </GridLayout>
      )}
    </div>
  )
}

export default DraggableColumn
